import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Toolbar } from "primereact/toolbar";
import { Menubar } from "primereact/menubar";

import { useTranslation } from "react-i18next";

import "primeicons/primeicons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Button } from "primereact/button";

import { FaRegBell } from "react-icons/fa";
import {
  VscDebugContinue,
  VscSymbolEvent,
  VscGraphLine,
  VscServerProcess,
  VscGraphScatter,
  VscPulse,
} from "react-icons/vsc";
import { use } from "react";

function AppTopbar(props) {
  const { title, menuCode } = props;
  const [hasEndProcess, setHasEndProcess] = useState(false);
  const [hasCurves, setHasCurves] = useState(false);
  const [hasAlarms, setHasAlarms] = useState(false);
  const [hasContinousData, setHasContinousData] = useState(false);
  const [hasEvents, setHasEvents] = useState(false);
  const [hasRunning, setHasRunning] = useState(false);

  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    const availableStoreTypes =
      JSON.parse(sessionStorage.getItem("availableStoreTypes")) || [];

    if (availableStoreTypes.length === 0) {
      return;
    }

    setHasEndProcess(availableStoreTypes.includes("STORE_ENDPROCESS"));
    setHasCurves(availableStoreTypes.includes("STORE_GRAPH"));
    setHasAlarms(
      availableStoreTypes.includes("STORE_ALARMS") ||
        availableStoreTypes.includes("STORE_ALARM")
    ); // handle singular vs plural
    setHasContinousData(availableStoreTypes.includes("STORE_REALTIME"));
    setHasEvents(availableStoreTypes.includes("STORE_EVENT"));
    setHasRunning(availableStoreTypes.includes("STORE_RUNNING"));
  }, []);

  const navigate = useNavigate();

  const languageMenu = {
    label: t("language"),
    icon: "pi pi-flag-fill",
    items: [
      {
        label: t("English"),
        icon: (
          <img
            src="/pms/flags/englishFlag.png"
            alt="English Flag"
            style={{ width: "30px", height: "30px", marginLeft: "1px" }}
          />
        ),
        command: () => changeLanguage("en"),
      },
      {
        label: t("German"),
        icon: (
          <img
            src="/pms/flags/germanFlag.png"
            alt="German Flag"
            style={{ width: "30px", height: "30px", marginLeft: "1px" }}
          />
        ),
        command: () => changeLanguage("de"),
      },
      {
        label: t("Italian"),
        icon: (
          <img
            src="/pms/flags/italianFlag.png"
            alt="Italian Flag"
            style={{ width: "30px", height: "30px", marginLeft: "1px" }}
          />
        ),
        command: () => changeLanguage("it"),
      },
      {
        label: t("French"),
        icon: (
          <img
            src="/pms/flags/frenchFlag.png"
            alt="French Flag"
            style={{ width: "30px", height: "30px", marginLeft: "1px" }}
          />
        ),
        command: () => changeLanguage("fr"),
      },
      {
        label: t("Danish"),
        icon: (
          <img
            src="/pms/flags/denmarkFlag.png"
            alt="Danish Flag"
            style={{ width: "30px", height: "30px", marginLeft: "1px" }}
          />
        ),
        command: () => changeLanguage("dk"),
      },
    ],
  };

  const userSettingsMenu = {
    label: t("userSettings"),
    icon: "pi pi-user",
    items: [
      {
        label: t("profile"),
        icon: "pi pi-id-card",
        command: () => navigate("/profile"),
      },
      {
        label: t("preferences"),
        icon: "pi pi-cog",
        command: () => navigate("/preferences"),
      },
    ],
  };

  const menuBarModel = [
    {
      label: t("menu"),
      icon: "pi pi-bars",
      items: [
        { ...languageMenu },
        // {
        //   label: t("settings"),
        //   icon: "pi pi-cog",
        //   items: [userSettingsMenu],
        // },
        {
          label: t("logout"),
          icon: "pi pi-sign-out",
          command: () => {
            sessionStorage.setItem("Logged", true);
            navigate("/");
          },
        },
      ],
    },
  ];

  const startContent = (
    <React.Fragment>
      <Button
        visible={hasEndProcess}
        label={t("endProcess")}
        icon={<VscServerProcess />}
        style={{ width: "200px", margin: "5px" }}
        onClick={() => navigate("/endprocess")}
      />
      <Button
        visible={hasCurves}
        label={t("curves")}
        icon={<VscPulse />}
        style={{ width: "200px", margin: "5px" }}
        onClick={() => navigate("/curves")}
      />
      <Button
        visible={hasAlarms}
        label={t("alarms")}
        icon={<FaRegBell />}
        style={{ width: "200px", margin: "5px" }}
        onClick={() => navigate("/alarms")}
      />
      <Button
        visible={hasContinousData}
        label={t("continousData")}
        icon={<VscGraphLine />}
        style={{ width: "200px", margin: "5px" }}
        onClick={() => navigate("/continousdata")}
      />
      <Button
        visible={hasEvents}
        label={t("events")}
        icon={<VscSymbolEvent />}
        style={{ width: "200px", margin: "5px" }}
        onClick={() => navigate("/events")}
      />
      <Button
        visible={hasRunning}
        label={t("running")}
        icon={<VscGraphScatter />}
        style={{ width: "200px", margin: "5px" }}
        onClick={() => navigate("/running")}
      />
    </React.Fragment>
  );

  const centerContent = (
    <React.Fragment>
      {menuCode === 6 && <VscServerProcess size={40} color="#E31E24" />}
      {menuCode === 5 && <VscPulse size={40} color="#E31E24" />}
      {menuCode === 4 && <VscGraphScatter size={40} color="#E31E24" />}
      {menuCode === 3 && <VscSymbolEvent size={40} color="#E31E24" />}
      {menuCode === 2 && <VscGraphLine size={40} color="#E31E24" />}
      {menuCode === 1 && <FaRegBell size={40} color="#E31E24" />}
      <h1 style={{ margin: "5px", textAlign: "center" }}>{title}</h1>
    </React.Fragment>
  );

  const endContent = (
    <React.Fragment>
      <img src="/pms/Cannon-C.jpg" alt="Logo" style={{ width: "4.7rem" }}></img>
      <Menubar
        model={menuBarModel}
        style={{
          width: "100%",

          fontWeight: "bold",
          fontSize: "16px",
        }}
      />
    </React.Fragment>
  );

  return (
    <div className="topbar" style={{ textAlign: "center" }}>
      <Toolbar
        className="p-toolbar"
        start={endContent}
        center={startContent}
        end={centerContent}
      />
    </div>
  );
}

export default AppTopbar;
